<template>
  <Splash class="Upload">
    <template slot="header">
      <h1>Replay Uploader</h1>
    </template>

    <template slot="caption">
      Upload one or multiple replays to be processed by WC3Stats. You can also automatically upload your replays using the <router-link :to="{ name: 'autoUploader' }">replay uploader program</router-link>.
    </template>

    <template slot="content">
      <form>
        <div class="File">
          <input type="file" id="replay" ref="files" @change="upload" multiple />
          <label for="replay">Browse Files</label>
        </div>
      </form>

      <div class="Upload-cards row">
        <div class="col-md-4" v-for="upload in uploads">
          <UploadCard :file="upload"></UploadCard>
        </div>
      </div>
    </template>

    <!-- -->
<!--
    <div ref="template" class="W3S--hidden">

    </div> -->

    <!-- -->

  </Splash>
</template>

<script>
  import Splash from '@/legacy/components/layout/Splash';
  import UploadCard from '@/legacy/components/UploadCard';
  import { metaFactory } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      return metaFactory ({
        title: 'Upload',
        description: 'Upload and parse Warcraft III replay files to generate detailed game, map and player statistics.'
      });
    },

    components: {
      Splash,
      UploadCard
    },

    data: function () {
      return {
        uploads: []
      };
    },

    methods: {
      upload: function () {
        this.uploads = this.uploads.concat (
          Array.from (this.$refs.files.files)
        )
      }
    }
  }
</script>

<style lang="scss">
  .Upload {
    // Other
    background:
      asset('background/home.jpg')               no-repeat,
      asset('background/home-repeat.jpg') center repeat-y;

    form {
      // Display & Border Box
      margin: 0 auto;
      width: 400px;
    }

    &-cards {
      // Display & Border Box
      margin: 80px 0 !important;

      // Text
      font-size: 12px;
      justify-content: center;
    }
  }
</style>